import React from "react";

import { Title } from "../../../../../components/dynamicanalysis";

export const QUOTA_EXCEEDED_MSG = "Quota exceeded";

const HistoryTitle: React.FC = () => (
  <Title headingLevel="h2" title="History of Dynamic Analysis Results" />
);

export default HistoryTitle;
